/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState, useCallback } from 'react'
import { RiArrowLeftLine, RiAddLargeLine, RiLogoutBoxRLine } from 'react-icons/ri'
import FooterHome from './footerHome'
import { Link } from 'react-router-dom'
import ApiFunction from '../../utils/api/apiFuntions'
import { useSelector } from 'react-redux'
import { decryptData } from '../../utils/api/encrypted'
import { Avatar, Megaphone } from '../icons/icons'

const Notification = () => {
    const [loading, setLoading] = useState(false);
    const { post } = ApiFunction();
    const encryptedToken = useSelector(state => state?.appData?.userToken);
    const userToken = decryptData(encryptedToken);
    const [notification, setNotification] = useState(null);
    const [groupedNotifications, setGroupedNotifications] = useState({});
    const intervalRef = useRef(null);
    const isLoadingRef = useRef(false);
    const userTokenRef = useRef(userToken);
    const [promoTitle, setPromoTitle] = useState('');
    const [promoMessage, setPromoMessage] = useState('');
    const [promoLink, setPromoLink] = useState('');

    // Update ref when userToken changes
    useEffect(() => {
        userTokenRef.current = userToken;
    }, [userToken]);
    const data = new FormData();
    data.append('type', 'get_data');
    data.append('table_name', 'preferences');
    data.append('id', 1);

    useEffect(() => {
        const getPreferences = async () => {
            setLoading(true);
            await post('', data)
                .then(response => {
                    if (response?.data) {
                        setPromoTitle(response?.data[0]?.promo_title);
                        setPromoMessage(response?.data[0]?.promo_message);
                        setPromoLink(response?.data[0]?.promo_link);
                    } else {
                        console.log("the response from server is not correct");
                    }
                })
                .catch(err => {
                    console.log("there is an error in the response =>", err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }

        getPreferences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const notiData = new FormData();
    notiData.append('type','update_all_data');
    notiData.append('table_name','notifications');
    notiData.append('user_id',userToken);
    notiData.append('seen',1);
    useEffect(()=>{
        const updateNotification = async ()=> {
            await post('',notiData)
            .then(res => {
                if(res?.result === true){
                    
                }
            })
            .catch(err => {

            })
            .finally(() => {

            })
        }
        updateNotification();
    })

    // Function to format date for display
    const formatDateForDisplay = (date) => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        const notificationDate = new Date(date);

        if (notificationDate.toDateString() === today.toDateString()) {
            return 'Today';
        } else if (notificationDate.toDateString() === yesterday.toDateString()) {
            return 'Yesterday';
        } else {
            return notificationDate.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        }
    };

    // Function to check if notification is within 30 minutes
    const isWithin30Minutes = (timestamp) => {
        const now = new Date();
        const notificationTime = new Date(timestamp);
        const diffInMinutes = (now - notificationTime) / (1000 * 60);
        return diffInMinutes <= 30;
    };

    // Function to format time with AM/PM
    const formatTimeWithAMPM = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    // Function to group notifications
    const groupNotificationsByTime = (notifications) => {
        const groups = {
            newMessages: [],
            today: [],
            yesterday: [],
            older: {}
        };

        notifications.forEach(notification => {
            const timestamp = notification.timestamp;

            if (isWithin30Minutes(timestamp)) {
                groups.newMessages.push(notification);
            } else {
                const dateKey = formatDateForDisplay(timestamp);

                if (dateKey === 'Today') {
                    groups.today.push(notification);
                } else if (dateKey === 'Yesterday') {
                    groups.yesterday.push(notification);
                } else {
                    if (!groups.older[dateKey]) {
                        groups.older[dateKey] = [];
                    }
                    groups.older[dateKey].push(notification);
                }
            }
        });

        // Sort notifications within each group by timestamp (newest first)
        groups.newMessages.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        groups.today.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        groups.yesterday.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

        Object.keys(groups.older).forEach(key => {
            groups.older[key].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        });

        return groups;
    };

    // API call function with useCallback for stability
    const getNotification = useCallback(async (showLoader = true) => {
        if (!userTokenRef.current || isLoadingRef.current) return;

        isLoadingRef.current = true;

        const data = new FormData();
        data.append('type', 'notifications');
        data.append('user_id', userTokenRef.current);

        if (showLoader) {
            setLoading(true);
        }

        try {
            const res = await post('', data);
            if (res?.result) {
                setNotification(res?.service);
                const grouped = groupNotificationsByTime(res?.service);
                setGroupedNotifications(grouped);
                console.log("Notifications =>", res);
                console.log("Grouped notifications =>", grouped);
            }
        } catch (err) {
            console.log("Error from notifications API =>", err);
        } finally {
            if (showLoader) {
                setLoading(false);
            }
            isLoadingRef.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // No dependencies for stable function

    useEffect(() => {
        if (!userToken) return;

        // Clear any existing interval
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        // Call immediately with loader
        getNotification(true);

        // Set interval for every 10 seconds (without loader for subsequent calls)
        intervalRef.current = setInterval(() => {
            console.log('Notification interval triggered at:', new Date().toLocaleTimeString());
            getNotification(false); // No loader for interval calls
        }, 10000);

        // Cleanup function
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [userToken, getNotification]);

    // Cleanup interval on unmount
    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    // Helper function to check if image is valid
    const hasValidImage = (imageUrl) => {
        return imageUrl && typeof imageUrl === 'string' && imageUrl.trim() !== '' && imageUrl.toLowerCase() !== 'https://app.hangnetwork.com/images/';
    };

const NotificationCard = ({ notification }) => {
    const renderNotificationIcon = () => {
        if (notification?.type === 'check_in') {
            return (
                <div className='flex items-center justify-center min-w-[48px] w-[48px] h-[48px] bg-[#EBF1FF] rounded-full'>
                    <RiAddLargeLine className='w-[20px] h-[20px] text-[#335CFF]' />
                </div>
            );
        } else if (notification?.type === 'check_out') {
            return (
                <div className='flex items-center justify-center min-w-[48px] w-[48px] h-[48px] bg-[#FFF3EB] rounded-full'>
                    <RiLogoutBoxRLine className='w-[20px] h-[20px] text-[#FA7319]' />
                </div>
            );
        } else if (hasValidImage(notification?.image)) {
            return (
                <div className='relative min-w-[48px]'>
                    <img 
                        src={notification?.image} 
                        className='w-[48px] h-[48px] rounded-full object-cover' 
                        alt="notification" 
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = '<div class="min-w-[48px]"><svg>...</svg></div>';
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div className='min-w-[48px]'>
                    <img src={Avatar} className='w-[48px] h-[48px] shadow-sm' alt="" />
                </div>
            );
        }
    };

    return (
        <div className="bg-white rounded-[12px] p-4 border border-[#E1E4EA]">
            <div className='flex gap-[12px]'>
                {renderNotificationIcon()}
                <div className='flex items-start flex-col gap-[8px] w-full'>
                    <div className='flex items-start justify-between w-full gap-2'>
                        <h2 className='mb-0 fs_16 britti_semibold text-[#0E121B]'>{notification?.title}</h2>
                        <span className='fs_14 text-[#0E121B] whitespace-nowrap  britti'>
                            {formatTimeWithAMPM(notification?.timestamp)}
                        </span>
                    </div>
                    <p className='britti_regular fs_14 text-[#0E121B] mb-0'>{notification?.notification}</p>
                </div>
            </div>
        </div>
    );
};

// Component to render old notification card
const OldNotificationCard = ({ notification }) => {
    const renderNotificationIcon = () => {
        if (notification?.type === 'check_in') {
            return (
                <div className='flex items-center justify-center min-w-[48px] w-[48px] h-[48px] bg-[#EBF1FF] rounded-full'>
                    <RiAddLargeLine className='w-[20px] h-[20px] text-[#335CFF]' />
                </div>
            );
        } else if (notification?.type === 'check_out') {
            return (
                <div className='flex items-center justify-center min-w-[48px] w-[48px] h-[48px] bg-[#FFF3EB] rounded-full'>
                    <RiLogoutBoxRLine className='w-[20px] h-[20px] text-[#FA7319]' />
                </div>
            );
        } else if (hasValidImage(notification?.image)) {
            return (
                <div className='relative min-w-[48px]'>
                    <img 
                        src={notification?.image} 
                        className='w-[48px] h-[48px] rounded-full object-cover' 
                        alt="notification"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                    {notification?.seen === '0' && (
                        <div className='absolute bottom-0 right-0 w-[12px] h-[12px] bg-[#335CFF] rounded-full border-2 border-white'></div>
                    )}
                </div>
            );
        } else {
            return (
                <div className='relative min-w-[48px]'>
                    <img src={Avatar} className='w-[48px] h-[48px]' alt="" />
                    {notification?.seen === '0' && (
                        <div className='absolute bottom-0 right-0 w-[12px] h-[12px] bg-[#335CFF] rounded-full border-2 border-white'></div>
                    )}
                </div>
            );
        }
    };

    return (
        <div className="bg-white rounded-[12px] p-4 border border-[#E1E4EA]">
            <div className='flex gap-[12px]'>
                {renderNotificationIcon()}
                <div className='flex items-start flex-col gap-[8px] w-full'>
                    <div className='flex items-start justify-between w-full gap-2'>
                        <h2 className='mb-0 fs_16 britti_semibold text-[#0E121B]'>{notification?.title}</h2>
                        <span className='fs_14 text-[#0E121B] whitespace-nowrap britti'>
                            {formatTimeWithAMPM(notification?.timestamp)}
                        </span>
                    </div>
                    <p className='britti_regular fs_14 text-[#0E121B] mb-0'>{notification?.notification}</p>
                </div>
            </div>
        </div>
    );
};

    return (
        <>
            <div className='h_100vh bg-[#F7F8FA]'>
                <div className="p-4 border-b border-[#E1E4EA] relative bg-white">
                    <Link to={'/setting'} className='absolute top-[23px] left-[20px] z-10'>
                        <RiArrowLeftLine className='w-[24px] h-[24px]' />
                    </Link>
                    <h1 className='fs_18 mb-0 text-center britti_semibold relative top-[3px]'>Notifications</h1>
                </div>

                <div className='main_body p-4'>
                    <div className='gap-[16px] flex flex-col '>
                        {promoTitle && promoTitle !== '' && promoMessage && promoMessage !== '' && (
                            <a href={promoLink}>
                                <h1 className='text-[#8F9098] fs_14 mb-3 britti_medium'>Promotions</h1>
                                <div className='bg-[#EDF4FF] flex gap-4 px-4 py-3 rounded-[16px]'>
                                    <img src={Megaphone} alt="" className='w-[40px] h-[40px]' />
                                    <div>
                                        <h1 className='fs_14 britti_bold text-[#0E121B] mb-1'>{promoTitle}</h1>
                                        <p className='fs_14 text-[#0E121B] britti_regular mb-0'>{promoMessage}</p>
                                    </div>
                                </div>
                            </a>
                        )}

                        {loading ? (
                            <div className="text-center py-8">
                                <p className='text-[#8F9098] fs_16'>Loading notifications...</p>
                            </div>
                        ) : (
                            <>
                                {/* New Messages (within 30 minutes) */}
                                {groupedNotifications?.newMessages?.length > 0 && (
                                    <div>
                                        <h1 className='text-[#8F9098] fs_14 mb-3 britti_medium'>New Message</h1>
                                        <div className='gap-[12px] flex flex-col'>
                                            {groupedNotifications.newMessages.map((notification, idx) => (
                                                <NotificationCard key={`new-${idx}`} notification={notification} />
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Today's Messages (older than 30 minutes) */}
                                {groupedNotifications?.today?.length > 0 && (
                                    <div>
                                        <h1 className='text-[#8F9098] fs_14 mb-3 britti_medium'>Today</h1>
                                        <div className='gap-[12px] flex flex-col'>
                                            {groupedNotifications.today.map((notification, idx) => (
                                                <OldNotificationCard key={`today-${idx}`} notification={notification} />
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Yesterday's Messages */}
                                {groupedNotifications?.yesterday?.length > 0 && (
                                    <div>
                                        <h1 className='text-[#8F9098] fs_14 mb-3 britti_medium'>Yesterday</h1>
                                        <div className='gap-[12px] flex flex-col'>
                                            {groupedNotifications.yesterday.map((notification, idx) => (
                                                <OldNotificationCard key={`yesterday-${idx}`} notification={notification} />
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Older Messages (grouped by date) */}
                                {Object.keys(groupedNotifications?.older || {}).map(dateKey => (
                                    <div key={dateKey}>
                                        <h1 className='text-[#8F9098] fs_14 mb-3 britti_medium'>{dateKey}</h1>
                                        <div className='gap-[12px] flex flex-col'>
                                            {groupedNotifications.older[dateKey].map((notification, idx) => (
                                                <OldNotificationCard key={`${dateKey}-${idx}`} notification={notification} />
                                            ))}
                                        </div>
                                    </div>
                                ))}

                                {/* No notifications message */}
                                {(!groupedNotifications?.newMessages?.length &&
                                    !groupedNotifications?.today?.length &&
                                    !groupedNotifications?.yesterday?.length &&
                                    Object.keys(groupedNotifications?.older || {}).length === 0) && (
                                        <div className='text-center py-8'>
                                            <p className='text-[#8F9098] fs_16'>No notifications found</p>
                                        </div>
                                    )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            {/* <FooterHome /> */}
        </>
    )
}

export default Notification